import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@/lib/router-compat";
import { supabase } from "@/integrations/supabase/client";

/**
 * Standard sign-out hygiene used by every logged-in surface:
 * cancel in-flight queries → clear cached protected data → end session →
 * replace history so Back can't restore a protected route.
 */
export function useSignOut(defaultTo: string = "/auth") {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useCallback(
    async (to: string = defaultTo) => {
      try {
        await queryClient.cancelQueries();
        queryClient.clear();
        await supabase.auth.signOut();
      } catch {
        // ignore — always land the user on a public route
      }
      navigate(to, { replace: true });
    },
    [queryClient, navigate, defaultTo],
  );
}

export default useSignOut;
